/**
 * Route for `campaign-status-filter`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CampaignStatusFilterPage } from "../features/campaign-status-filter/CampaignStatusFilterPage";

export const campaignStatusFilterRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/campaign-status-filter",
	component: CampaignStatusFilterPage,
});

export default campaignStatusFilterRoute;
